export class StorageAccountContainerRestoreDestination {
    'storageAccountResourceGroupName';
    'storageAccountName';
    'containerName';
    'prefix';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageAccountResourceGroupName",
            "baseName": "storageAccountResourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageAccountName",
            "baseName": "storageAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "containerName",
            "baseName": "containerName",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StorageAccountContainerRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
